<template>
    <b-overlay :show="showOverlay" class="overlay">        
        
        <div v-if="items && items.length === 0">
            <div class="text-center">
                Aún no se ha realizado ningún intento
            </div>
        </div>

        <div v-else-if="items">
            <b-table small :items="items" :fields="fields" sticky-header="20vh">
                <template #cell(note)="row">
                    <EvaluationGrade :grade="row.item.note"/>
                </template>
            </b-table>
        </div>
    </b-overlay>
</template>

<script>

import { formatDateTime } from '@/plugins/complianceScripts';
import EvaluationGrade from '@/components/shared/Training/Evaluation-grade.vue';

export default {
    name: 'EvaluationQualificationsList',

    props: {
        items: Array,
    },

    components: {
        EvaluationGrade
    },

    data() {
        return {
            fields: [
                {'key': 'creationDate', 'label': 'Fecha', formatter: formatDateTime},
                {'key': 'note', 'label': 'Calificación (%)', thClass: 'col-4'},
            ]
        }
    },

    computed: {
        showOverlay() {
            return this.items === undefined;
        }
    }
}
</script>
<style scoped>
.overlay {
    min-height: 25px;
}
</style>